var _path, _polygon, _polygon2, _polygon3, _polygon4, _rect, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteezyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "currentColor",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 449.03 87.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tSTEEZY_NOT_BLACK\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.25,50a19.74,19.74,0,0,0-6-6h0c-8.69-5.92-21.4-7.14-28.79-10.7-3.6-1.73-5.95-4-5.95-7.66C18.51,19.7,22.73,17,29.7,17c8.79,0,13.3,4,14,11.53L61,24.17C59.44,10,48.93,0,29.65,0,11.63,0,0,10.52,0,25.64,0,31.15,1.33,35.3,3.51,38.5A20.14,20.14,0,0,0,9.2,44h0c9,6.14,22.4,7.22,29.63,11.12C42,56.79,43.94,59,43.94,62.34c0,5.94-4.22,8.68-11.2,8.68-8.58,0-13.07-3.83-13.92-10.92L1.49,64.42C3.27,78.3,13.76,88,32.74,88c18,0,29.66-10.52,29.66-25.64A22.45,22.45,0,0,0,59.25,50Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "150.91 86.45 211.67 86.45 211.67 69.47 168.11 69.47 168.11 52.51 211.67 52.51 211.67 35.53 150.91 35.53 150.91 86.45"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.83 18.52 94.58 18.52 94.58 86.45 111.83 86.45 111.83 18.52 133.59 18.52 133.59 1.54 72.83 1.54 72.83 18.52"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.95 18.52 343.81 18.52 306.96 69.45 306.95 69.45 306.95 86.43 366.29 86.43 366.29 69.45 329.45 69.45 366.29 18.52 366.29 1.54 306.95 1.54 306.95 18.52"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "228.96 86.45 289.72 86.45 289.72 69.47 246.16 69.47 246.16 52.51 289.72 52.51 289.72 35.53 228.96 35.53 228.96 86.45"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150.91,
    y: 1.57,
    width: 138.81,
    height: 16.98
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "428.46 1.54 412.89 35.53 397.31 1.54 376.74 1.54 404.26 52.62 404.26 86.45 421.51 86.45 421.51 53.92 449.03 1.54 428.46 1.54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteezyLogo);
export default __webpack_public_path__ + "static/media/steezy-logo.cbdba47c.svg";
export { ForwardRef as ReactComponent };